import { Button, Collapse, Stack } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { basePath, dashboardPath } from "../../../routes/routes";
import {
  borderStyle,
  boxHeight,
  defaultGap,
  defaultTransition,
  iconGap,
  iconSize,
  perelynLightGrey,
  sidebarWidth,
  smallerGap,
  tinyGap,
} from "../../../styles/consts";
import { flip } from "../../../utils";
import { useLayoutConfig } from "../../context/LayoutConfigProvider";
import { useSnackbar } from "../../context/SnackbarProvider";
import { GreyOnHoverStack, OrangeOnHoverStack } from "../../styles/Box.styles";
import {
  MainSidebarComponent,
  MiddleSidebarComponent,
} from "../../styles/Sidebar.styles";
import { HeadingText } from "../../styles/Text.styles";
import Icon, { BiggerIcon } from "../fundamentals/Icon";

export default function SecondarySidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const { moduleName } = useLayoutConfig();
  const [isFolded, setIsFolded] = useState(true);

  const isCreateButtonDisabled =
    location.pathname.includes("/alqemi") ||
    location.pathname.includes("/linkedin");

  const handleToolSettings = () => {
    if (
      moduleName === "pdf-data-extraction" ||
      moduleName === "marketing-text" ||
      moduleName === "alqemi"
    ) {
      navigate(`${basePath(moduleName)}/settings`);
    } else {
      showSnackbar("This feature is not available yet.", true, true);
    }
  };

  const handleBackToToolHistory = () => {
    if (location.pathname === dashboardPath(moduleName)) {
      navigate(`/`);
    } else {
      navigate(dashboardPath(moduleName));
    }
  };

  const handleFold = () => {
    flip(setIsFolded)();
  };

  return (
    <Collapse
      in={!isFolded}
      orientation="horizontal"
      collapsedSize={boxHeight}
      sx={{
        width: isFolded
          ? `${boxHeight} !important`
          : `${sidebarWidth} !important`,
        maxWidth: isFolded
          ? `${boxHeight} !important`
          : `${sidebarWidth} !important`,
        minWidth: isFolded
          ? `${boxHeight} !important`
          : `${sidebarWidth} !important`,
        borderRight: borderStyle,
        transition: defaultTransition,
      }}
    >
      <MainSidebarComponent>
        <Stack>
          <Button
            variant="orangeBig"
            sx={{
              borderBottom: borderStyle,
              gap: iconGap,
              paddingRight: isFolded ? "11rem " : "0",
              "&:disabled": {
                borderBottom: borderStyle,
                backgroundColor: perelynLightGrey,
              },
            }}
            disabled={isCreateButtonDisabled}
          >
            <BiggerIcon
              sx={{
                width: defaultGap,
                height: defaultGap,
                filter: isCreateButtonDisabled
                  ? "brightness(0) saturate(100%) invert(67%) sepia(6%) saturate(94%) hue-rotate(21deg) brightness(95%) contrast(87%)"
                  : "none",
              }}
              name="Plus"
            />
            {!isFolded && "Create new"}
          </Button>

          <Button
            variant="transparentBig"
            sx={{
              borderBottom: borderStyle,
              gap: iconGap,
              paddingRight: isFolded ? "11rem " : "0",
            }}
            onClick={handleFold}
          >
            <BiggerIcon
              sx={{
                width: defaultGap,
                height: defaultGap,
                transform: isFolded ? "scaleX(-1)" : "none",
                transition: defaultTransition,
              }}
              name="DoubleChevron"
            />
          </Button>
        </Stack>

        <MiddleSidebarComponent
          sx={{
            transition: defaultTransition,
            "&&": {
              padding: isFolded
                ? "0rem 11rem 1rem 1.5rem"
                : `${defaultGap} ${smallerGap} ${defaultGap} ${defaultGap}`,
              alignItems: "left",
            },
          }}
        >
          <Stack
            sx={{
              gap: smallerGap,
              display: isFolded ? "none" : "flex",
              textWrap: "nowrap",
            }}
          >
            <HeadingText>Tool History</HeadingText>
            <Stack gap={tinyGap}>
              <Stack gap={tinyGap}>
                <Stack flexDirection="row" alignItems="center" gap={iconGap}>
                  <GreyOnHoverStack>
                    <Icon name="Folder" />
                    Folder open
                    <Icon name="ChevronUp" />
                    <Icon name="DragComponent" />
                  </GreyOnHoverStack>
                </Stack>

                {/* <Stack flexDirection="row" alignItems="center" gap={iconGap}>
                  <Icon name="RedFile" />
                  <OrangeSidebarStack>Task 1</OrangeSidebarStack>
                </Stack> */}
              </Stack>
              <Stack>Favorite Tools</Stack>
              <Stack>Submit Idea</Stack>
            </Stack>
          </Stack>

          <OrangeOnHoverStack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              gap: iconGap,
              marginTop: isFolded ? "auto" : "0",
              textWrap: "nowrap",
            }}
            onClick={handleToolSettings}
          >
            <Icon
              sx={{
                transition: defaultTransition,
                width: isFolded ? "1.75rem" : iconSize,
                height: isFolded ? "1.75rem" : iconSize,
              }}
              name="Settings"
            />
            {!isFolded && "Tool Settings"}
          </OrangeOnHoverStack>
        </MiddleSidebarComponent>

        <Stack>
          {location.pathname === "/marketing-text/dashboard" && (
            <Button
              variant="transparentBig"
              id="arena"
              sx={{
                borderTop: borderStyle,
                paddingRight: isFolded ? "11rem " : "0",
              }}
            >
              {isFolded ? (
                <BiggerIcon
                  sx={{
                    width: "1.75rem",
                    height: "1.75rem",
                  }}
                  name="Stars"
                />
              ) : (
                "Compare prompts"
              )}
            </Button>
          )}

          <Button
            variant="transparentBig"
            id="return"
            sx={{
              borderTop: borderStyle,
              paddingRight: isFolded ? "11rem " : "0",
            }}
            onClick={handleBackToToolHistory}
          >
            {isFolded ? (
              <BiggerIcon
                sx={{
                  width: defaultGap,
                  height: defaultGap,
                  minHeight: defaultGap,
                  maxHeight: defaultGap,
                }}
                name="Return"
              />
            ) : (
              "Back to tool history overview"
            )}
          </Button>
        </Stack>
      </MainSidebarComponent>
    </Collapse>
  );
}
